import { createClient, SupabaseClient } from '@supabase/supabase-js'

// Simple direct initialization with better error handling
let supabase: SupabaseClient | null = null

try {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

  console.log('🔍 Environment Debug Info:')
  console.log('Supabase URL:', supabaseUrl)
  console.log('Supabase Anon Key:', supabaseAnonKey ? 'Present' : 'Missing')
  console.log('MODE:', import.meta.env.MODE)
  console.log('DEV:', import.meta.env.DEV)
  console.log('PROD:', import.meta.env.PROD)

  if (supabaseUrl && supabaseAnonKey) {
    console.log('Creating Supabase client...')
    supabase = createClient(supabaseUrl, supabaseAnonKey)
    console.log('✅ Supabase client created successfully')
  } else {
    console.warn('❌ Missing Supabase environment variables')
    console.warn('Please create a .env.local file with:')
    console.warn('VITE_SUPABASE_URL=your_supabase_url')
    console.warn('VITE_SUPABASE_ANON_KEY=your_supabase_anon_key')

    // Create a fallback client for development
    if (import.meta.env.DEV) {
      console.log('Creating fallback client for development...')
      supabase = createClient('https://dummy.supabase.co', 'dummy-key', {
        auth: {
          persistSession: false,
          autoRefreshToken: false,
          detectSessionInUrl: false
        }
      })
      console.log('⚠️ Using fallback Supabase client (auth disabled)')
    }
  }
} catch (error) {
  console.error('❌ Failed to create Supabase client:', error)
  supabase = null
}

export { supabase }
